import { useMemo } from 'react'
import { PROMO_END_DATE, PROMO_START_DATE } from '../config/dvoinoi-shans-na-pobedu/dates'

export const useIsDvoinoiShansNaPobeduActive = () => {
  const { isStarted, isEnded, isPromoActive } = useMemo(() => {
    const now = Date.now()
    const startDate = new Date(PROMO_START_DATE).getTime()
    const endDate = new Date(PROMO_END_DATE).getTime()

    const isStarted = now >= startDate
    const isEnded = now >= endDate
    const isPromoActive = isStarted && !isEnded

    return { isStarted, isEnded, isPromoActive }
  }, [])

  return { isStarted, isEnded, isPromoActive }
}
